import React from "react";
import Flx from "../../layout/Flx";

const RffGroupContainer = ({ children, flexDirection, sx }) => {
  return (
    <Flx
      fw
      sx={{
        flexDirection: flexDirection,
        ".rff-group": {
          mb: 8,
        },
        ...sx,
      }}
    >
      {children}
    </Flx>
  );
};

export default RffGroupContainer;
